import React, { ReactElement } from 'react';
import {
  CircleStyled,
  FilterCount,
  FilterText,
  FlightFilterCard,
} from './FlightFilter.styles';

interface Props {
  status: string;
  description: string;
  current?: boolean;
  onFilter: () => void;
  totalDocsMatching: number;
}

export function FlightFilter(props: Props): ReactElement {
  const { current = false, status, description, onFilter, totalDocsMatching } = props;
  return (
    <FlightFilterCard current={current} onClick={onFilter}>
      <FilterCount>
        <CircleStyled current={current}>{totalDocsMatching}</CircleStyled>
      </FilterCount>
      <FilterText>
        <h2>{status}</h2>
        <p>{description}</p>
      </FilterText>
    </FlightFilterCard>
  );
}
